<div class="mb-2">
   <div class="{{field.styleValue}}">
    <ds-truncatable [id]="truncableId">
      <ds-truncatable-part [id]="truncableId" [minLines]="3">
        {{metadataValue.value}}
      </ds-truncatable-part>
    </ds-truncatable>
  </div>
</div>
